const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M727.75,234.087c-0.828-38.978-23.513-76.605-58.065-105.651 c-20.213-16.992-44.536-31.878-71.09-43.469c-27.558-12.03-57.519-25.502-90.771-27.57c-8.206-0.51-16.622-0.266-24.721,1.364 c-31.009,6.24,30.352,28.48,38.372,31.732C435.71,65.731,346.936,40.572,253.184,42.945c-18.077,0.458-36.829,2.1-52.722,8.873 C184.57,58.59,172.27,71.652,174.637,84.6c1.956,10.703,12.664,22.66,2.621,31.025c-2.872,2.392-6.943,3.806-10.94,5.034 c-20.509,6.3-42.649,9.604-62.077,17.618c-30.086,12.411-50.618,35.214-60.135,59.207c-9.516,23.993-9.06,49.204-5.324,73.61 c7.03,45.933,26.147,91.501,64.835,127.222c55.261,51.023,145.859,77.012,236.607,81.295 c109.809,5.182,228.864-21.962,301.475-84.789c10.769-9.318,20.644-19.641,24.561-31.327c3.917-11.686,0.814-25.002-11.241-32.676 c-3.249-2.068-7.43-4.261-7.078-7.471c0.477-4.343,8.206-5.811,14.097-6.723c38.652-5.982,60.758-37.633,64.745-66.097 C727.553,245.034,727.865,239.547,727.75,234.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M727.75,234.087c-0.828-38.978-23.513-76.605-58.065-105.651 c-20.213-16.992-44.536-31.878-71.09-43.469c-27.558-12.03-57.519-25.502-90.771-27.57c-8.206-0.51-16.622-0.266-24.721,1.364 c-31.009,6.24,30.352,28.48,38.372,31.732C435.71,65.731,346.936,40.572,253.184,42.945c-18.077,0.458-36.829,2.1-52.722,8.873 C184.57,58.59,172.27,71.652,174.637,84.6c1.956,10.703,12.664,22.66,2.621,31.025c-2.872,2.392-6.943,3.806-10.94,5.034 c-20.509,6.3-42.649,9.604-62.077,17.618c-30.086,12.411-50.618,35.214-60.135,59.207c-9.516,23.993-9.06,49.204-5.324,73.61 c7.03,45.933,26.147,91.501,64.835,127.222c55.261,51.023,145.859,77.012,236.607,81.295 c109.809,5.182,228.864-21.962,301.475-84.789c10.769-9.318,20.644-19.641,24.561-31.327c3.917-11.686,0.814-25.002-11.241-32.676 c-3.249-2.068-7.43-4.261-7.078-7.471c0.477-4.343,8.206-5.811,14.097-6.723c38.652-5.982,60.758-37.633,64.745-66.097 C727.553,245.034,727.865,239.547,727.75,234.087z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M485.648,388.889"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clouds"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M403.163,77.997 c0,0-16.266-30.849-39.823-38.14c-23.557-7.292-37.579,0.561-43.188,8.413c-5.609,7.852-6.731,16.266-6.731,16.266 s-30.288-8.974-39.262-0.561c-8.974,8.413-6.17,20.753-6.17,20.753s-21.874-4.487-26.922,3.365 c-5.048,7.852-5.048,11.778-5.048,11.778s-18.509-0.561-21.313,2.805c-2.804,3.365-4.487,6.731-4.487,6.731l-16.826,3.926H465.42 l-18.509-6.731c0,0-6.731-26.922-16.826-35.336C419.989,62.854,411.015,65.097,403.163,77.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M403.163,77.997 c0,0-3.365,6.73,0,18.509c0,0-10.096-7.292-18.509-4.487c-8.413,2.804-7.853,10.096-7.853,10.096"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M313.421,64.536 l-0.561,12.339c0,0-11.218-7.291-17.948-1.683c-6.731,5.609-4.487,15.144-4.487,15.144s-6.731,0-8.413,2.243 c-1.683,2.244-1.683,2.244-1.683,2.244"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M558.659,144.697 c0,0-8.575-16.264-20.995-20.108c-12.419-3.844-19.812,0.296-22.769,4.436c-2.957,4.14-3.548,8.575-3.548,8.575 s-15.968-4.731-20.699-0.296c-4.731,4.436-3.253,10.941-3.253,10.941s-11.532-2.365-14.194,1.774 c-2.661,4.14-2.661,6.21-2.661,6.21s-9.758-0.296-11.237,1.479c-1.478,1.774-2.366,3.548-2.366,3.548l-8.871,2.07h143.415 l-9.758-3.548c0,0-3.548-14.194-8.871-18.629C567.53,136.713,562.799,137.896,558.659,144.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M558.659,144.697 c0,0-1.774,3.548,0,9.758c0,0-5.323-3.844-9.758-2.366c-4.435,1.479-4.14,5.323-4.14,5.323"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M511.347,137.6 l-0.296,6.505c0,0-5.914-3.844-9.462-0.887s-2.366,7.984-2.366,7.984s-3.548,0-4.436,1.183c-0.887,1.183-0.887,1.183-0.887,1.183"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M133.901,156.263 c0,0-8.575-16.264-20.995-20.108c-12.42-3.844-19.812,0.296-22.769,4.436c-2.957,4.14-3.548,8.575-3.548,8.575 s-15.968-4.731-20.699-0.296c-4.731,4.435-3.253,10.941-3.253,10.941s-11.532-2.365-14.194,1.774s-2.661,6.21-2.661,6.21 s-9.758-0.296-11.237,1.479c-1.478,1.774-2.366,3.548-2.366,3.548l-8.871,2.07h143.415l-9.758-3.548 c0,0-3.548-14.194-8.871-18.629S138.04,149.462,133.901,156.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M133.901,156.263 c0,0-1.774,3.548,0,9.758c0,0-5.323-3.844-9.758-2.366c-4.436,1.479-4.14,5.323-4.14,5.323"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M86.588,149.166 l-0.296,6.505c0,0-5.914-3.844-9.463-0.887s-2.366,7.984-2.366,7.984s-3.549,0-4.436,1.183c-0.887,1.183-0.887,1.183-0.887,1.183"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Trees"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M201.732,240.455c0,48.674-28.793,88.131-64.311,88.131c-35.519,0-64.312-39.458-64.312-88.131 S101.901,24.494,137.42,24.494C172.938,24.494,201.732,191.782,201.732,240.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M201.732,240.455c0,48.674-28.793,88.131-64.311,88.131 c-35.519,0-64.312-39.458-64.312-88.131S101.901,24.494,137.42,24.494C172.938,24.494,201.732,191.782,201.732,240.455z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B2B2B2"
    },
    points: "102.679,244.83 123.191,251.986 133.353,265.798 131.576,308.089 119.752,300.065  131.208,316.841 129.498,440.54 142.445,441.206 139.415,284.7 173.48,265.92 154.007,273.122 157.914,261.401 148.604,275.121  139.309,278.559 138.645,240.065 172.476,195.118 154.345,213.249 157.412,200.642 148.739,218.856 138.457,229.138  137.42,168.997 133.735,256.71 101.675,222.736 119.285,246.675  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M172.801,169.188c0,0,0.595,5.909-2.635,10.246c-3.229,4.337-9.06,5.461-9.06,5.461 s-0.595-5.908,2.635-10.246C166.969,170.312,172.801,169.188,172.801,169.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M192.184,196.422c0,0,0.595,5.909-2.635,10.246c-3.23,4.337-9.061,5.461-9.061,5.461 s-0.595-5.908,2.635-10.246C186.353,197.546,192.184,196.422,192.184,196.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M192.175,249.446c0,0-1.428,5.764-5.93,8.761c-4.501,2.997-10.37,2.093-10.37,2.093 s1.429-5.764,5.93-8.761C186.306,248.542,192.175,249.446,192.175,249.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M85.722,249.446c0,0,1.429,5.764,5.93,8.761c4.501,2.997,10.37,2.093,10.37,2.093 s-1.429-5.764-5.93-8.761C91.591,248.542,85.722,249.446,85.722,249.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M169.787,227.436c0,0,0.595,5.909-2.635,10.246c-3.23,4.338-9.061,5.462-9.061,5.462 s-0.595-5.909,2.635-10.246C163.956,228.56,169.787,227.436,169.787,227.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.766,139.562c0,0,0.595,5.909-2.635,10.246c-3.23,4.338-9.061,5.461-9.061,5.461 s-0.595-5.908,2.635-10.246C158.935,140.686,164.766,139.562,164.766,139.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M153.217,162.158c0,0,0.595,5.908-2.635,10.246c-3.23,4.338-9.061,5.462-9.061,5.462 s-0.595-5.908,2.635-10.246C147.386,163.282,153.217,162.158,153.217,162.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M180.634,145.706c0,0,0.595,5.909-2.634,10.246c-3.23,4.337-9.061,5.461-9.061,5.461 s-0.595-5.908,2.635-10.246C174.804,146.83,180.634,145.706,180.634,145.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M91.54,145.706c0,0-0.595,5.909,2.634,10.246c3.23,4.337,9.061,5.461,9.061,5.461 s0.595-5.908-2.635-10.246C97.371,146.83,91.54,145.706,91.54,145.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M167.277,111.944c0,0,0.595,5.908-2.635,10.246c-3.229,4.337-9.06,5.462-9.06,5.462 s-0.595-5.908,2.635-10.246C161.446,113.068,167.277,111.944,167.277,111.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M161.601,82.607c0,0,2.06,5.57,0.024,10.579c-2.036,5.01-7.398,7.563-7.398,7.563 s-2.06-5.57-0.024-10.58C156.24,85.16,161.601,82.607,161.601,82.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M120.932,74.941c0,0,5.261,2.755,7.104,7.839c1.844,5.084-0.427,10.571-0.427,10.571 s-5.261-2.756-7.104-7.839C118.661,80.428,120.932,74.941,120.932,74.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M139.897,110.022c0,0,3.747,4.607,3.437,10.006c-0.311,5.399-4.562,9.546-4.562,9.546 s-3.747-4.607-3.437-10.006C135.646,114.169,139.897,110.022,139.897,110.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.893,57.8c0,0,3.747,4.607,3.437,10.006c-0.31,5.399-4.561,9.545-4.561,9.545 s-3.747-4.607-3.437-10.005C134.642,61.947,138.893,57.8,138.893,57.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M96.329,169.188c0,0-0.595,5.909,2.635,10.246c3.23,4.337,9.061,5.461,9.061,5.461 s0.595-5.908-2.635-10.246C102.16,170.312,96.329,169.188,96.329,169.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M85.282,201.325c0,0-0.595,5.909,2.635,10.246c3.23,4.338,9.061,5.462,9.061,5.462 s0.595-5.909-2.635-10.246C91.113,202.449,85.282,201.325,85.282,201.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M114.606,212.992c0,0-0.595,5.909,2.635,10.246c3.229,4.337,9.06,5.462,9.06,5.462 s0.595-5.909-2.634-10.246C120.437,214.116,114.606,212.992,114.606,212.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.624,168.463c0,0-2.262,5.49-0.41,10.571c1.852,5.081,7.117,7.828,7.117,7.828 s2.262-5.491,0.41-10.572C127.889,171.209,122.624,168.463,122.624,168.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M101.858,286.954c0,0,5.938,0.109,9.996-3.466c4.058-3.574,4.7-9.478,4.7-9.478 s-5.938-0.108-9.995,3.466C102.501,281.05,101.858,286.954,101.858,286.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M158.833,280.459c0,0,1.613,5.715,6.208,8.567c4.595,2.851,10.432,1.759,10.432,1.759 s-1.613-5.715-6.208-8.566C164.67,279.367,158.833,280.459,158.833,280.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M108.482,139.562c0,0-0.595,5.909,2.635,10.246c3.23,4.338,9.061,5.461,9.061,5.461 s0.595-5.908-2.635-10.246C114.313,140.686,108.482,139.562,108.482,139.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M108.38,113.451c0,0-0.595,5.909,2.635,10.246c3.229,4.337,9.061,5.462,9.061,5.462 s0.595-5.909-2.635-10.246C114.211,114.575,108.38,113.451,108.38,113.451z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M309.54,277.8c0,39.619-23.437,71.736-52.348,71.736c-28.911,0-52.348-32.117-52.348-71.736 s23.437-175.786,52.348-175.786C286.103,102.014,309.54,238.181,309.54,277.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M309.54,277.8c0,39.619-23.437,71.736-52.348,71.736 c-28.911,0-52.348-32.117-52.348-71.736s23.437-175.786,52.348-175.786C286.103,102.014,309.54,238.181,309.54,277.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B2B2B2"
    },
    points: "228.914,281.362 245.611,287.186 253.882,298.429 252.435,332.852 242.811,326.321  252.136,339.976 250.743,440.664 261.283,441.206 258.816,313.814 286.544,298.528 270.693,304.39 273.874,294.849  266.296,306.017 258.73,308.816 258.189,277.483 285.727,240.897 270.969,255.655 273.465,245.393 266.405,260.219  258.036,268.588 257.192,219.636 254.192,291.031 228.097,263.378 242.431,282.863  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M285.991,219.79c0,0,0.484,4.809-2.145,8.34c-2.629,3.531-7.375,4.445-7.375,4.445 s-0.484-4.809,2.145-8.34C281.244,220.705,285.991,219.79,285.991,219.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301.768,241.958c0,0,0.484,4.809-2.145,8.34c-2.629,3.53-7.375,4.445-7.375,4.445 s-0.484-4.809,2.145-8.34C297.022,242.873,301.768,241.958,301.768,241.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301.762,285.118c0,0-1.163,4.692-4.827,7.131c-3.664,2.44-8.441,1.703-8.441,1.703 s1.163-4.692,4.827-7.131C296.984,284.382,301.762,285.118,301.762,285.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M215.111,285.118c0,0,1.163,4.692,4.827,7.131c3.664,2.44,8.441,1.703,8.441,1.703 s-1.163-4.692-4.827-7.131C219.889,284.382,215.111,285.118,215.111,285.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.538,267.203c0,0,0.484,4.809-2.145,8.34c-2.629,3.531-7.375,4.446-7.375,4.446 s-0.484-4.809,2.145-8.34C278.792,268.118,283.538,267.203,283.538,267.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M279.451,195.676c0,0,0.484,4.809-2.145,8.34c-2.629,3.531-7.375,4.446-7.375,4.446 s-0.484-4.809,2.145-8.34C274.705,196.591,279.451,195.676,279.451,195.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M270.051,214.068c0,0,0.484,4.809-2.145,8.34c-2.629,3.531-7.375,4.446-7.375,4.446 s-0.484-4.809,2.145-8.34C265.304,214.983,270.051,214.068,270.051,214.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M292.367,200.677c0,0,0.484,4.809-2.144,8.34c-2.629,3.531-7.375,4.445-7.375,4.445 s-0.484-4.809,2.145-8.34C287.621,201.592,292.367,200.677,292.367,200.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M219.847,200.677c0,0-0.484,4.809,2.144,8.34c2.629,3.531,7.375,4.445,7.375,4.445 s0.484-4.809-2.145-8.34C224.593,201.592,219.847,200.677,219.847,200.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.495,173.196c0,0,0.484,4.809-2.145,8.34c-2.629,3.53-7.375,4.445-7.375,4.445 s-0.484-4.809,2.145-8.34C276.749,174.111,281.495,173.196,281.495,173.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.875,149.316c0,0,1.677,4.534,0.019,8.611c-1.657,4.078-6.021,6.156-6.021,6.156 s-1.677-4.534-0.019-8.612C272.511,151.394,276.875,149.316,276.875,149.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M243.772,143.076c0,0,4.282,2.243,5.783,6.381c1.501,4.138-0.348,8.604-0.348,8.604 s-4.282-2.243-5.783-6.381C241.923,147.543,243.772,143.076,243.772,143.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M259.209,171.631c0,0,3.05,3.75,2.798,8.144c-0.253,4.395-3.713,7.77-3.713,7.77 s-3.05-3.75-2.798-8.145C255.748,175.007,259.209,171.631,259.209,171.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M258.391,129.124c0,0,3.05,3.75,2.797,8.144c-0.253,4.394-3.713,7.77-3.713,7.77 s-3.05-3.75-2.798-8.144C254.931,132.499,258.391,129.124,258.391,129.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M223.745,219.79c0,0-0.484,4.809,2.145,8.34c2.629,3.531,7.375,4.445,7.375,4.445 s0.484-4.809-2.145-8.34C228.492,220.705,223.745,219.79,223.745,219.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M214.753,245.949c0,0-0.484,4.809,2.145,8.34c2.629,3.531,7.375,4.446,7.375,4.446 s0.484-4.809-2.145-8.34C219.5,246.864,214.753,245.949,214.753,245.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M238.622,255.446c0,0-0.484,4.809,2.145,8.34c2.629,3.531,7.375,4.446,7.375,4.446 s0.484-4.809-2.144-8.34C243.369,256.361,238.622,255.446,238.622,255.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M245.148,219.2c0,0-1.841,4.469-0.333,8.605c1.507,4.136,5.793,6.372,5.793,6.372 s1.841-4.469,0.333-8.605C249.434,221.436,245.148,219.2,245.148,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228.246,315.649c0,0,4.833,0.089,8.136-2.821c3.303-2.909,3.826-7.715,3.826-7.715 s-4.833-0.088-8.136,2.821C228.769,310.843,228.246,315.649,228.246,315.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.622,310.362c0,0,1.313,4.652,5.053,6.973c3.74,2.321,8.491,1.432,8.491,1.432 s-1.313-4.652-5.053-6.973C279.373,309.473,274.622,310.362,274.622,310.362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M233.638,195.676c0,0-0.484,4.809,2.145,8.34c2.629,3.531,7.375,4.446,7.375,4.446 s0.484-4.809-2.145-8.34C238.384,196.591,233.638,195.676,233.638,195.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M233.555,174.422c0,0-0.484,4.809,2.145,8.34c2.629,3.531,7.375,4.446,7.375,4.446 s0.484-4.809-2.145-8.34C238.301,175.337,233.555,174.422,233.555,174.422z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M709.455,277.8c0,39.619-23.437,71.736-52.348,71.736c-28.911,0-52.348-32.117-52.348-71.736 s23.437-175.786,52.348-175.786C686.018,102.014,709.455,238.181,709.455,277.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M709.455,277.8c0,39.619-23.437,71.736-52.348,71.736 c-28.911,0-52.348-32.117-52.348-71.736s23.437-175.786,52.348-175.786C686.018,102.014,709.455,238.181,709.455,277.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B2B2B2"
    },
    points: "628.829,281.362 645.525,287.186 653.796,298.429 652.35,332.852 642.725,326.321  652.05,339.976 650.658,440.664 661.197,441.206 658.73,313.814 686.459,298.528 670.608,304.39 673.788,294.849 666.21,306.017  658.644,308.816 658.104,277.483 685.641,240.897 670.883,255.655 673.38,245.393 666.32,260.219 657.951,268.588  657.107,219.636 654.107,291.031 628.011,263.378 642.345,282.863  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M685.905,219.79c0,0,0.484,4.809-2.145,8.34c-2.629,3.531-7.375,4.445-7.375,4.445 s-0.484-4.809,2.145-8.34C681.159,220.705,685.905,219.79,685.905,219.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M701.683,241.958c0,0,0.484,4.809-2.145,8.34c-2.629,3.53-7.375,4.445-7.375,4.445 s-0.484-4.809,2.145-8.34C696.937,242.873,701.683,241.958,701.683,241.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M701.676,285.118c0,0-1.163,4.692-4.827,7.131c-3.663,2.44-8.441,1.703-8.441,1.703 s1.163-4.692,4.827-7.131C696.899,284.382,701.676,285.118,701.676,285.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M615.026,285.118c0,0,1.163,4.692,4.827,7.131c3.664,2.44,8.441,1.703,8.441,1.703 s-1.163-4.692-4.827-7.131C619.803,284.382,615.026,285.118,615.026,285.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M683.453,267.203c0,0,0.484,4.809-2.144,8.34c-2.629,3.531-7.375,4.446-7.375,4.446 s-0.484-4.809,2.145-8.34C678.706,268.118,683.453,267.203,683.453,267.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M679.366,195.676c0,0,0.484,4.809-2.145,8.34c-2.629,3.531-7.375,4.446-7.375,4.446 s-0.484-4.809,2.145-8.34C674.619,196.591,679.366,195.676,679.366,195.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M669.965,214.068c0,0,0.484,4.809-2.145,8.34c-2.629,3.531-7.375,4.446-7.375,4.446 s-0.484-4.809,2.145-8.34C665.219,214.983,669.965,214.068,669.965,214.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M692.282,200.677c0,0,0.484,4.809-2.144,8.34c-2.629,3.531-7.375,4.445-7.375,4.445 s-0.484-4.809,2.145-8.34C687.536,201.592,692.282,200.677,692.282,200.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M619.762,200.677c0,0-0.484,4.809,2.144,8.34c2.629,3.531,7.375,4.445,7.375,4.445 s0.484-4.809-2.145-8.34C624.508,201.592,619.762,200.677,619.762,200.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M681.409,173.196c0,0,0.484,4.809-2.145,8.34c-2.629,3.53-7.375,4.445-7.375,4.445 s-0.484-4.809,2.145-8.34C676.663,174.111,681.409,173.196,681.409,173.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M676.789,149.316c0,0,1.677,4.534,0.019,8.611c-1.657,4.078-6.022,6.156-6.022,6.156 s-1.677-4.534-0.019-8.612C672.425,151.394,676.789,149.316,676.789,149.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M643.686,143.076c0,0,4.282,2.243,5.783,6.381c1.501,4.138-0.348,8.604-0.348,8.604 s-4.282-2.243-5.783-6.381C641.838,147.543,643.686,143.076,643.686,143.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M659.123,171.631c0,0,3.05,3.75,2.798,8.144c-0.253,4.395-3.713,7.77-3.713,7.77 s-3.05-3.75-2.798-8.145C655.663,175.007,659.123,171.631,659.123,171.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M658.306,129.124c0,0,3.05,3.75,2.797,8.144c-0.253,4.394-3.713,7.77-3.713,7.77 s-3.05-3.75-2.798-8.144C654.846,132.499,658.306,129.124,658.306,129.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M623.66,219.79c0,0-0.484,4.809,2.145,8.34c2.629,3.531,7.375,4.445,7.375,4.445 s0.484-4.809-2.145-8.34C628.406,220.705,623.66,219.79,623.66,219.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M614.668,245.949c0,0-0.484,4.809,2.145,8.34c2.629,3.531,7.375,4.446,7.375,4.446 s0.484-4.809-2.145-8.34C619.414,246.864,614.668,245.949,614.668,245.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M638.537,255.446c0,0-0.484,4.809,2.145,8.34c2.628,3.531,7.375,4.446,7.375,4.446 s0.484-4.809-2.144-8.34C643.283,256.361,638.537,255.446,638.537,255.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M645.063,219.2c0,0-1.841,4.469-0.333,8.605c1.508,4.136,5.793,6.372,5.793,6.372 s1.841-4.469,0.334-8.605C649.348,221.436,645.063,219.2,645.063,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M628.161,315.649c0,0,4.833,0.089,8.136-2.821c3.303-2.909,3.826-7.715,3.826-7.715 s-4.833-0.088-8.136,2.821C628.684,310.843,628.161,315.649,628.161,315.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M674.536,310.362c0,0,1.313,4.652,5.053,6.973c3.74,2.321,8.491,1.432,8.491,1.432 s-1.313-4.652-5.053-6.973C679.287,309.473,674.536,310.362,674.536,310.362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M633.552,195.676c0,0-0.484,4.809,2.145,8.34c2.629,3.531,7.375,4.446,7.375,4.446 s0.484-4.809-2.145-8.34C638.299,196.591,633.552,195.676,633.552,195.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M633.469,174.422c0,0-0.484,4.809,2.145,8.34c2.629,3.531,7.375,4.446,7.375,4.446 s0.484-4.809-2.145-8.34C638.216,175.337,633.469,174.422,633.469,174.422z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rocks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5B5B5"
    },
    d: "M654.956,219.908c-0.952-5.714-9.523-8.571-24.76-8.571c-15.237,0-254.267,67.614-274.266,79.042 c-19.023,10.87-188.818,134.604-205.346,146.656h438.451c4.324-11.107,26.301-67.511,29.733-75.233 c3.809-8.571,21.903-31.426,26.665-38.092c4.761-6.666,2.857-12.38,0.952-23.808c-1.905-11.428-3.809-23.808-3.809-23.808 s9.523-27.617,11.428-32.379C655.908,238.954,655.908,225.622,654.956,219.908z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.31
    },
    d: "M643.127,279.646c-0.343-2.198-0.552-3.551-0.552-3.551s9.523-27.617,11.428-32.379 c-9.523-1.905-38.092,0-47.616,7.618c-9.523,7.618,0,9.523,6.666,8.571c6.666-0.952,17.142-3.809,17.142-3.809 s5.714,4.762-8.571,11.428c-14.285,6.666,7.619-17.142-63.805,15.237c-71.423,32.379-119.039,47.616-111.421,52.377 c7.619,4.761,66.662-14.285,60.948-5.714c-5.714,8.571-12.38,12.38-42.854,18.094c-30.474,5.714-61.9,9.523-74.28,11.428 c-12.38,1.905,0-17.142,11.428-26.665c11.428-9.523,2.857-19.046-21.903-7.618c-24.76,11.428-89.517,58.091-88.565,63.805 c0.952,5.714,51.425-12.38,44.759-3.809c-6.666,8.571-98.088,39.045-107.611,45.711c-3.311,2.318-7.308,4.629-11.12,6.666 h352.448c5.834-12.054,21.176-43.739,27.034-55.743c1.012-2.072,1.74-3.558,2.088-4.253c2.857-5.714,1.905,23.808,5.714,13.332 c3.809-10.475,13.332-51.425,19.046-66.662c5.714-15.237-2.857-8.571-5.714-6.666c-2.857,1.905-4.762,1.905,2.857-15.237 C624.939,292.207,633.986,287.384,643.127,279.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5B5B5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M654.956,226.574c0,0,0.246,0.549,0.605,1.44c-0.01-0.525-0.023-1.04-0.042-1.548 C655.168,226.523,654.956,226.574,654.956,226.574z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.31,
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M594.96,240.859 c0,0-69.519,19.999-78.09,31.426c-8.571,11.428,25.713-1.905,47.616-11.428C586.389,251.335,606.388,240.859,594.96,240.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.31,
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M494.967,291.332c0,0-45.711,8.571-28.569,16.189l52.377-21.903L494.967,291.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.31,
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M278.793,376.087l-42.854,35.235c0,0,0.952,6.666,17.142-5.714c16.189-12.38,52.377-37.14,43.806-38.092 C288.316,366.564,278.793,376.087,278.793,376.087z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5B5B5"
    },
    d: "M559.453,437.035c2.443-2.025,4.834-4.178,5.986-5.714c2.857-3.809,25.712-34.283,31.426-41.902 c5.714-7.618,35.123-15.958,33.219-20.719c-1.905-4.761-36.076-4.041-74.168,14.053c-31.884,15.145-88.444,44.963-106.037,54.282 H559.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5B5B5"
    },
    d: "M661.096,437.035c-1.707-5.313-4.599-13.732-7.092-18.094 c-3.809-6.666-20.951-10.475-20.951-10.475s1.905-25.712,0.952-34.283c-0.952-8.571-9.523-5.714-9.523-5.714 s-33.331,16.189-38.093,22.856c-2.387,3.342-10.996,16.255-18.989,28.305c-7.748,5.31-24.818,16.758-24.818,14.549 c0-2.857,4.762-11.428,11.428-24.76c5.618-11.237-19.203,18.113-27.145,27.617H661.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.31
    },
    d: "M661.096,437.035c-1.707-5.313-4.599-13.732-7.092-18.094 c-3.809-6.666-20.951-10.475-20.951-10.475s1.905-25.712,0.952-34.283c-0.952-8.571-9.523-5.714-9.523-5.714 s-33.331,16.189-38.093,22.856c-2.387,3.342-10.996,16.255-18.989,28.305c-7.748,5.31-24.818,16.758-24.818,14.549 c0-2.857,4.762-11.428,11.428-24.76c5.618-11.237-19.203,18.113-27.145,27.617H661.096z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M97.425,391.961c-3.55,0.578-8.525,3.472-10.734,4.918c-2.058,0.604-4.076,1.311-6.043,2.121 c1.873-1.65,6.932-6.164,6.049-10.585c-1.417-5.712-8.065-1.056-7.917,3.666c-0.025,3.882-0.467,6.805-1.126,8.251 c-2.178,1.035-4.289,2.192-6.323,3.468c1.519-1.885,5.797-7.223,4.154-11.472c-2.357-5.39-8.057,0.287-7.117,4.912 c0.639,3.849,0.696,6.812,0.284,8.338c-1.974,1.384-3.862,2.884-5.661,4.484c1.158-2.067,4.541-8.096,2.184-12.036 c-3.223-4.919-7.875,1.615-6.179,6.019c1.277,3.697,1.827,6.616,1.67,8.187c-1.715,1.689-3.331,3.478-4.842,5.356 c0.81-2.263,3.13-8.76,0.154-12.234c-3.999-4.314-7.508,2.921-5.106,6.99c1.869,3.429,2.894,6.218,3.001,7.804 c-1.411,1.952-2.715,3.985-3.894,6.099c0.223-1.247,0.63-3.589,0.527-5.974c1.027-1.788,1.011-3.538-0.824-3.964 c-0.368-0.828-0.878-1.568-1.579-2.15c-0.366-0.282-0.716-0.485-1.051-0.634c3.329-2.198,4.78-6.046-0.431-6.052 c-4.66-0.167-6.886,5.478-7.541,8.035c-0.312-2.244-0.505-4.503-0.568-6.764c1.025-1.212,3.502-2.723,7.092-3.674 c4.282-1.292,7.32-5.461,1.685-6.425c-4.562-0.937-7.697,4.226-8.772,6.626c0.064-2.249,0.25-4.495,0.559-6.726 c1.209-1.023,3.906-2.1,7.612-2.439c4.436-0.555,8.133-4.171,2.74-6.069c-4.372-1.695-8.352,2.955-9.79,5.126 c0.435-2.218,1.001-4.414,1.683-6.58c1.354-0.818,4.207-1.446,7.944-1.162c4.467,0.191,8.741-2.791,3.749-5.574 c-4.052-2.422-8.81,1.597-10.574,3.498c0.749-1.98,1.608-3.927,2.571-5.832c1.807-1.747,5.215-4.885,6.728-6.116 c1.993-1.907,3.846-4.622,2.93-6.478c-0.881-1.861-4.474-2.787-6.97,1.213c-1.992,2.995-3.257,8.609-3.701,11.212 c-0.958,1.919-1.813,3.878-2.559,5.872c0.066-2.495,0.201-9.274-3.639-11.635c-5.149-2.848-6.262,5.191-2.702,8.296 c2.827,2.66,4.668,4.973,5.28,6.441c-0.723,2.3-1.312,4.635-1.762,6.993c-0.348-2.396-1.348-9.163-5.579-10.85 c-5.553-1.941-5.272,6.1-1.244,8.558c3.255,2.151,5.465,4.126,6.303,5.466c-0.329,2.388-0.515,4.793-0.567,7.2 c-0.727-2.255-2.842-8.837-7.333-9.791c-5.798-0.986-4.175,6.869,0.205,8.624c3.579,1.58,6.091,3.163,7.135,4.348 c0.071,2.406,0.282,4.807,0.63,7.193c-1.106-2.133-4.289-8.255-8.859-8.438c-5.882-0.006-2.969,7.489,1.647,8.498 c3.785,0.964,6.525,2.111,7.761,3.111c0.47,2.362,1.073,4.702,1.819,7.004c-1.504-1.999-5.652-7.438-10.134-6.852 c-5.803,0.978-1.652,7.946,3.08,8.184c3.865,0.324,6.753,1.003,8.163,1.788c1.014,2.637,2.209,5.217,3.598,7.717 c-0.08,0.246,0.044,0.509,0.279,0.605c0.012,0.005,0.023,0.009,0.035,0.013c0.257,0.084,0.534-0.057,0.618-0.314 c0.875-2.68,1.937-5.275,3.162-7.776c1.467-0.641,4.4-0.873,8.069-0.053c4.406,0.817,9.07-1.499,4.535-4.977 c-3.63-3.003-8.922,0.266-10.969,1.914c1.137-2.017,2.391-3.959,3.743-5.825c1.554-0.351,4.45-0.055,7.89,1.373 c4.191,1.57,9.15,0.103,5.264-4.09c-3.049-3.528-8.699-1.318-11.019-0.057c1.432-1.756,2.956-3.434,4.57-5.019 c1.585-0.074,4.378,0.713,7.518,2.697c3.86,2.258,8.983,1.648,5.855-3.138c-2.418-3.98-8.334-2.764-10.825-1.919 c1.691-1.484,3.463-2.875,5.309-4.167c1.572,0.19,4.197,1.432,6.967,3.918c3.425,2.872,8.59,3.12,6.311-2.122 c-1.733-4.357-7.849-4.109-10.418-3.686c1.922-1.191,3.915-2.27,5.966-3.244c1.521,0.435,3.923,2.099,6.258,5.03 c2.9,3.403,7.993,4.506,6.636-1.047c-0.983-4.617-7.166-5.368-9.759-5.367c1.962-0.799,3.973-1.494,6.024-2.086 c2.513,0.136,7.13,0.498,9.059,0.768c2.754,0.163,6.004-0.327,6.741-2.261C103.821,394.33,102.054,391.066,97.425,391.961z  M43.141,415.697c-0.383,1.175-0.44,2.612-0.103,3.945c-1.141,2.063-1.557,4.575-1.66,6.025c-0.704-2.206-1.274-4.446-1.721-6.707 C40.201,418.027,41.382,416.845,43.141,415.697z M45.674,435.806c-1.189-2.218-2.231-4.495-3.125-6.82 c0.407-1.162,1.579-2.793,3.51-4.456c1.301,1.931,2.114,3.544,2.386,4.652C47.397,431.324,46.471,433.535,45.674,435.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M731.412,387.787c-3.714,0.605-8.918,3.632-11.23,5.145c-2.153,0.632-4.263,1.371-6.322,2.219 c1.959-1.726,7.252-6.448,6.328-11.073c-1.483-5.975-8.437-1.104-8.283,3.835c-0.026,4.061-0.489,7.118-1.178,8.632 c-2.278,1.083-4.487,2.293-6.615,3.628c1.589-1.972,6.065-7.556,4.345-12.001c-2.466-5.638-8.429,0.301-7.446,5.139 c0.668,4.027,0.728,7.127,0.297,8.723c-2.065,1.448-4.04,3.017-5.922,4.691c1.211-2.163,4.751-8.47,2.285-12.591 c-3.372-5.146-8.238,1.69-6.464,6.297c1.336,3.868,1.911,6.921,1.746,8.565c-1.794,1.767-3.484,3.639-5.065,5.603 c0.848-2.367,3.274-9.164,0.161-12.798c-4.183-4.513-7.854,3.056-5.341,7.312c1.956,3.587,3.027,6.504,3.14,8.164 c-1.476,2.042-2.84,4.169-4.074,6.38c0.234-1.304,0.659-3.755,0.552-6.249c1.075-1.871,1.058-3.701-0.862-4.148 c-0.385-0.866-0.918-1.64-1.652-2.249c-0.383-0.294-0.749-0.508-1.1-0.664c3.483-2.299,5.001-6.325-0.451-6.331 c-4.875-0.175-7.203,5.731-7.888,8.406c-0.326-2.348-0.528-4.71-0.594-7.076c1.072-1.268,3.663-2.848,7.42-3.843 c4.479-1.351,7.658-5.713,1.763-6.722c-4.772-0.98-8.052,4.421-9.177,6.932c0.067-2.353,0.261-4.702,0.585-7.036 c1.265-1.07,4.086-2.197,7.963-2.551c4.641-0.581,8.508-4.364,2.866-6.349c-4.574-1.774-8.737,3.091-10.242,5.362 c0.455-2.321,1.047-4.618,1.761-6.883c1.417-0.856,4.401-1.512,8.311-1.215c4.673,0.2,9.144-2.919,3.922-5.831 c-4.239-2.533-9.216,1.671-11.061,3.66c0.784-2.072,1.682-4.108,2.689-6.101c1.89-1.828,5.456-5.11,7.038-6.398 c2.085-1.995,4.023-4.835,3.065-6.777c-0.922-1.947-4.681-2.915-7.291,1.269c-2.084,3.133-3.407,9.006-3.872,11.729 c-1.002,2.008-1.897,4.057-2.677,6.143c0.069-2.61,0.21-9.702-3.807-12.172c-5.387-2.98-6.55,5.431-2.826,8.679 c2.958,2.783,4.883,5.203,5.523,6.738c-0.757,2.406-1.373,4.848-1.843,7.315c-0.363-2.507-1.41-9.586-5.837-11.35 c-5.809-2.03-5.516,6.381-1.301,8.953c3.405,2.251,5.717,4.316,6.593,5.718c-0.344,2.498-0.539,5.014-0.593,7.532 c-0.761-2.359-2.973-9.245-7.671-10.243c-6.065-1.032-4.368,7.186,0.215,9.021c3.744,1.653,6.372,3.309,7.465,4.549 c0.074,2.516,0.295,5.029,0.659,7.524c-1.157-2.232-4.487-8.636-9.268-8.827c-6.154-0.006-3.106,7.835,1.723,8.89 c3.959,1.008,6.826,2.208,8.119,3.255c0.492,2.471,1.122,4.918,1.903,7.327c-1.573-2.091-5.913-7.78-10.601-7.168 c-6.07,1.023-1.728,8.313,3.222,8.561c4.044,0.339,7.064,1.049,8.539,1.871c1.061,2.758,2.311,5.458,3.763,8.073 c-0.084,0.257,0.046,0.532,0.292,0.633c0.012,0.005,0.024,0.01,0.036,0.014c0.269,0.088,0.559-0.059,0.647-0.329 c0.915-2.803,2.027-5.518,3.308-8.135c1.535-0.67,4.602-0.913,8.442-0.056c4.609,0.855,9.489-1.568,4.744-5.207 c-3.798-3.142-9.333,0.278-11.475,2.002c1.19-2.11,2.501-4.142,3.916-6.094c1.626-0.367,4.655-0.057,8.254,1.436 c4.385,1.643,9.572,0.108,5.507-4.278c-3.189-3.691-9.101-1.378-11.527-0.06c1.498-1.837,3.092-3.592,4.781-5.251 c1.659-0.077,4.58,0.746,7.865,2.821c4.038,2.362,9.398,1.724,6.125-3.282c-2.529-4.164-8.718-2.892-11.324-2.008 c1.769-1.552,3.623-3.008,5.553-4.359c1.645,0.198,4.391,1.499,7.288,4.099c3.583,3.005,8.987,3.264,6.602-2.22 c-1.813-4.558-8.211-4.299-10.899-3.855c2.01-1.245,4.096-2.375,6.241-3.393c1.591,0.455,4.104,2.195,6.547,5.262 c3.034,3.56,8.362,4.713,6.942-1.095c-1.029-4.83-7.497-5.616-10.209-5.615c2.052-0.836,4.156-1.563,6.302-2.182 c2.628,0.142,7.459,0.521,9.476,0.804c2.881,0.17,6.281-0.342,7.052-2.366C738.103,390.265,736.254,386.852,731.412,387.787z  M674.625,412.618c-0.401,1.23-0.461,2.733-0.107,4.127c-1.194,2.158-1.629,4.786-1.737,6.303c-0.736-2.308-1.332-4.651-1.8-7.016 C671.548,415.056,672.784,413.819,674.625,412.618z M677.274,433.655c-1.244-2.32-2.334-4.703-3.269-7.135 c0.425-1.216,1.652-2.922,3.672-4.661c1.361,2.02,2.211,3.707,2.495,4.867C679.076,428.966,678.108,431.279,677.274,433.655z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 709.22,441.618 692.402,440.078 694.268,436.499 686.946,437.33 686.946,435.114 681.217,437.33 681.535,433.452 680.36,434.134  677.715,435.668 676.442,432.621 674.532,436.222 671.349,433.452 671.349,435.945 666.574,433.452 667.211,437.33  660.526,434.006 659.253,437.053 656.388,434.56 651.295,436.776 649.066,434.56 641.745,436.499 640.79,433.452 638.244,435.945  636.652,433.729 633.469,435.945 629.967,435.114 625.511,437.607 625.193,435.391 619.463,436.776 618.508,434.56  613.733,436.776 611.505,434.283 603.865,436.776 601,434.283 597.499,435.668 594.634,433.729 592.406,435.945 587.949,433.729  586.676,437.053 582.856,435.114 574.261,437.33 575.535,434.283 568.532,435.668 557.072,437.33 555.799,434.006 551.661,437.607  549.751,435.114 545.613,437.607 542.748,434.006 541.156,436.499 538.928,434.56 537.018,436.776 533.835,434.56 526.514,437.33  523.33,436.499 520.784,437.33 519.192,435.391 514.099,437.053 512.508,434.837 508.369,436.776 509.324,433.175 504.55,436.222  500.411,433.175 499.138,436.776 496.273,434.56 491.499,438.161 490.225,435.668 478.447,438.438 477.811,436.499  469.853,437.607 467.625,435.668 463.168,436.776 462.531,434.837 458.351,436.656 458.432,436.499 457.128,436.647  454.892,433.729 453.3,437.053 451.111,436.1 451.111,435.114 449.911,435.578 449.48,435.391 449.418,435.769 447.341,436.572  445.506,435.808 445.7,433.452 444.524,434.134 443.254,434.871 441.841,434.283 441.438,434.61 440.607,432.621 438.697,436.222  435.514,433.452 435.514,435.945 430.739,433.452 431.303,436.889 430.611,436.95 427.594,435.449 427.835,435.114  427.129,435.218 424.691,434.006 423.99,435.682 422.154,435.953 420.553,434.56 415.459,436.776 413.231,434.56 410.735,435.221  410.646,434.283 405.758,436.015 404.955,433.452 402.408,435.945 401.259,434.345 401.096,433.729 400.919,433.872  400.817,433.729 397.634,435.945 394.388,435.175 393.456,434.283 393.322,435.567 391.582,436.54 389.36,435.412 389.357,435.391  389.331,435.397 389.318,435.391 389.3,435.405 385.59,436.302 384.225,435.114 382.961,435.23 382.673,434.56 380.804,435.427  378.177,435.668 377.126,435.912 375.67,434.283 374.281,434.736 374.357,434.56 366.636,435.563 365.165,434.283 361.663,435.668  358.799,433.729 356.57,435.945 352.114,433.729 351.043,436.523 348.255,435.391 347.884,435.552 347.021,435.114  343.379,436.053 343.162,435.391 338.494,437.168 339.699,434.283 338.069,434.605 338.069,433.729 334.832,435.246  332.697,435.668 328.825,436.229 326.291,432.621 323.744,436.499 321.516,434.837 321.198,437.053 321.112,437.005  319.964,434.006 318.323,435.434 315.786,434.006 315.468,437.053 315.376,437.02 313.916,435.114 312.469,435.985 308.465,434.56  307.62,434.894 306.913,434.006 305.915,435.569 304.964,435.945 305.282,433.452 299.271,435.445 298,434.56 291.715,436.938  291.276,434.837 287.95,436.618 287.495,436.499 287.1,436.628 286.819,433.452 283.871,436.017 283.357,435.391 282.971,435.517  282.045,432.898 277.406,435.858 276.672,434.837 275.656,435.313 273.18,434.343 273.489,433.175 272.237,433.974  270.904,433.452 271.392,434.513 268.714,436.222 264.576,433.175 263.303,436.776 260.438,434.56 255.663,438.161 254.39,435.668  242.612,438.438 241.976,436.499 234.018,437.607 231.789,435.668 227.333,436.776 226.696,434.837 221.603,437.053  219.057,433.729 217.465,437.053 213.645,435.391 213.327,437.33 206.006,434.283 201.231,438.161 196.774,436.776 190.408,437.33  191.999,435.114 175.129,437.607 174.81,434.283 166.216,437.33 165.261,433.729 160.804,437.33 157.621,434.283 157.303,437.33  153.483,435.391 150.936,437.33 148.39,435.114 142.342,435.668 137.567,436.776 138.522,434.56 117.195,437.33 112.42,435.391  107.963,437.33 107.327,435.391 102.234,437.33 102.234,433.729 93.957,437.607 90.456,432.621 87.909,436.499 85.681,434.837  85.363,437.053 79.951,434.006 79.633,437.053 72.63,434.56 69.129,435.945 69.447,433.452 56.077,437.884 55.441,434.837  51.303,437.053 50.984,433.452 47.483,436.499 46.209,432.898 41.435,435.945 35.068,433.452 36.978,437.607 28.065,438.438  33.917,440.078 13.116,443.159 254.403,442.351 248.951,443.159  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fox_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M438.487,449.271 c0,0,34.46,5.841,50.813,4.672c16.354-1.168,12.265-10.221,8.469-13.141c-3.796-2.92-13.433-2.92-13.433-2.92 S456.885,448.687,438.487,449.271z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M533.112,351.639c0,0,15.825-2.584,29.389,20.023c13.564,22.607,32.295,36.816,37.785,31.326c5.49-5.49,0.323-10.98,0.323-10.98 s14.856-1.292,15.825,18.085c0.969,19.377-28.097,39.4-53.933,36.816c-25.836-2.584-41.984-19.7-53.287-34.556 c-11.303-14.856-20.346-17.439-20.346-17.439S489.837,360.681,533.112,351.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M600.609,392.008c0,0,5.167,5.49-0.323,10.98c-3.053,3.053-10.203,0.007-18.281-7.181l2.78,7.504c0,0-5.49-1.615-10.335-4.198 c-4.844-2.584-14.533-10.98-14.533-10.98s4.198,13.564,5.813,16.793c1.615,3.229,9.043,14.856,9.043,14.856 s-5.49-0.323-9.366-1.615c-3.875-1.292-11.303-5.49-11.303-5.49l6.782,9.366c0,0-4.198-0.969-11.626-4.198 c-7.428-3.229-10.334-5.167-10.334-5.167l10.657,20.023l7.751,7.751l-11.303-1.938c0,0,2.23,3.032,4.767,6.097 c3.666,1.093,7.559,1.886,11.703,2.3c25.836,2.584,54.902-17.439,53.933-36.816C615.465,390.716,600.609,392.008,600.609,392.008 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M502.432,393.24 c0,0,9.043,27.128,14.856,38.108c5.813,10.98,8.72,17.116,14.533,18.408c5.813,1.292,10.98-1.292,9.366-5.167 c-1.615-3.875-10.98-9.043-12.918-10.334s-9.366-21.315-6.782-32.295c2.584-10.98,10.657-27.128,10.657-27.128L502.432,393.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M490.483,252.757 c0,0,5.813,12.217,5.813,32.295c0,15.179-8.397,41.015-24.221,50.703c-15.825,9.689-45.556,26.453-57.808,44.244 c-23.575,34.233-2.584,56.516,12.595,65.882c15.179,9.366,49.411,3.552,60.715-4.198c11.303-7.751,18.085-19.7,15.502-30.034 c-2.584-10.334-2.584-10.334-2.584-10.334s14.856-9.043,31.326-19.377c16.47-10.334,19.054-21.315,18.085-26.482 c-0.969-5.167-0.969-5.167-0.969-5.167s3.552,8.72,4.844,4.521c1.292-4.198,2.261-12.595,0.646-16.147 c-1.615-3.552-5.813-11.626-5.813-11.626s7.105,3.229,4.198-3.875c-2.906-7.105-8.72-9.689-13.241-22.284 c-4.521-12.595-13.822-29.023-16.793-41.984c-2.971-12.961-4.844-17.439-4.844-17.439S496.619,244.037,490.483,252.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M548.614,327.035 c0,0,7.105,3.23,4.198-3.875c-2.906-7.105-8.72-9.688-13.241-22.283c-4.521-12.595-13.822-29.023-16.793-41.984 c-2.971-12.961-4.844-17.439-4.844-17.439s-7.787,0.947-15.303,3.62c3.386,7.617,10.529,24.966,12.72,40.302 c2.907,20.346,1.938,31.003-1.292,42.306c-3.229,11.303-12.272,33.587-22.93,41.338c-10.657,7.751-18.085,8.397-29.065,12.272 c-10.98,3.875-16.471,7.751-16.471,7.751s20.333-4.28,30.035-3.875c15.502,0.646,24.867,16.147,24.867,16.147 s14.856-9.043,31.326-19.377c16.47-10.334,19.054-21.315,18.085-26.482c-0.969-5.167-0.969-5.167-0.969-5.167 s3.552,8.72,4.844,4.521c1.292-4.198,2.261-12.595,0.646-16.147C552.812,335.109,548.614,327.035,548.614,327.035z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M539.662,198.122c0,0,2.874-11.458-2.351-27.395c-5.225-15.937-22.207-40.793-23.774-37.396 c-1.568,3.396-5.225,19.333-5.486,29.522c-0.261,10.189-0.784,13.585-0.784,13.585s-18.288-3.919-23.252-2.874 c-4.964,1.045-9.667,2.613-9.667,2.613s-20.9,0-28.999-2.874c-8.099-2.874-18.288-9.928-18.288-4.441 c0,5.486,3.396,20.639,10.711,25.864c7.315,5.225,21.162,8.621,21.162,8.621s-18.549,14.108-23.513,20.9 c-4.964,6.793-5.748,12.802-5.748,12.802l5.748-2.351c0,0-3.396,6.531-0.784,5.748c2.613-0.784,7.315-2.09,7.315-2.09 s-3.396,3.919-1.306,4.18c2.09,0.261,4.964-1.045,7.576-0.784c2.613,0.261,10.711,2.874,10.973,7.576 c0.261,4.703-1.306,13.324-4.18,19.594c-2.874,6.27-3.297,10.691,4.18,10.45c8.099-0.261,13.063-1.829,25.864-10.973 c12.802-9.144,13.063-15.937,34.747-22.468c21.684-6.531,30.567,4.18,32.657,3.396c2.09-0.784,0.523-4.964,0.523-4.964 s4.964,9.405,5.748,6.793c0.784-2.613-1.829-15.414-1.829-15.414s6.793,10.189,6.009,2.351 c-0.784-7.838-8.36-19.594-14.892-27.954C541.491,201.78,539.662,198.122,539.662,198.122z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M462.138,175.772c-6.061-0.373-12.9-1.089-16.789-2.469c-8.099-2.874-18.288-9.928-18.288-4.441 c0,4.339,2.126,14.718,6.632,21.457c9.868-1.894,24.451-5.149,27.309-8.308C462.711,180.12,462.739,177.847,462.138,175.772z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M537.996,172.964c-0.213-0.736-0.437-1.48-0.686-2.237c-5.225-15.937-22.207-40.793-23.774-37.396 c-1.568,3.396-5.225,19.333-5.486,29.522c-0.116,4.527-0.284,7.707-0.434,9.851c9.391,4.32,21.819,8.996,26.081,5.834 C535.438,177.245,536.85,175.256,537.996,172.964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M474.348,176.176 c0,0-8.883,3.919-4.703,4.441c4.18,0.522,13.585,0,13.585,0s-9.666,2.351-9.144,8.621c0.523,6.27,11.495-2.613,11.495-2.613 s-1.306,4.703,1.045,3.135c2.351-1.567,4.441-5.748,4.441-5.748"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M499.69,255.86 c0,0,13.063-9.667,14.63-27.693"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M510.663,228.428 c0,0,5.748-2.613,8.883-0.523"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M459.195,249.328 c0,0,2.613-17.765-2.874-28.216"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M507.434,174.946c0.451,1.842,1.368,5.356,3.229,11.942c3.396,12.018,10.189,18.811,16.198,17.765 c6.009-1.045,6.793-10.189-0.523-36.837c-7.315-26.648-12.802-34.486-12.802-34.486c-1.568,3.396-5.225,19.333-5.486,29.522 C507.883,169.369,507.61,173.098,507.434,174.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M437.772,194.726c7.315,5.225,21.162,8.622,21.162,8.622s4.441-3.396,6.009-4.964c1.568-1.568,4.703-5.748-1.568-4.441 c-6.27,1.306-20.9-6.27-25.342-13.324c-4.441-7.054-10.973-11.757-10.973-11.757 C427.061,174.348,430.457,189.501,437.772,194.726z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M460.763,216.41c0,0-0.261-3.135,5.486-5.225c5.748-2.09,8.621-0.261,8.621-0.261 s-3.658-5.748-9.666-4.18C459.195,208.311,460.763,216.41,460.763,216.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M500.474,215.887c0,0,0.261-3.135-5.486-5.225c-5.748-2.09-8.621-0.261-8.621-0.261 s3.658-5.748,9.666-4.18C502.041,207.788,500.474,215.887,500.474,215.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M470.429,223.986c0,2.741-0.936,4.964-2.09,4.964s-2.09-2.222-2.09-4.964 c0-2.742,0.936-4.964,2.09-4.964S470.429,221.245,470.429,223.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M493.42,225.293c0,2.742-0.936,4.964-2.09,4.964c-1.154,0-2.09-2.222-2.09-4.964 c0-2.741,0.936-4.964,2.09-4.964C492.484,220.329,493.42,222.551,493.42,225.293z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M467.641,278.172c0.331-10.459-6.555-12.5-11.258-12.682c-0.416,1.192-0.871,2.349-1.368,3.433 c-2.874,6.27-3.297,10.691,4.18,10.45C462.261,279.274,464.878,278.985,467.641,278.172z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M478.211,349.642 c0,0,0.646,14.21-0.969,24.867c-1.615,10.657-4.521,20.669-4.521,20.669l4.198-4.844l0.323,9.366l5.49-8.397 c0,0-0.969,14.21,3.229,26.482c4.198,12.272,13.564,32.295,17.439,35.525c3.875,3.229,13.887,6.459,17.762,3.229 c3.875-3.229,4.844-6.136,1.615-9.043c-3.23-2.907-12.595-3.23-13.564-3.875c-0.969-0.646-10.98-19.7-9.689-29.389 c1.292-9.689,21.315-23.575,18.731-47.797c-2.584-24.221-14.533-42.63-14.533-42.63"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fox_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M322.292,396.621 c0,0,8.57,25.709,14.079,36.115c5.509,10.406,8.264,16.221,13.773,17.446c5.509,1.224,10.406-1.224,8.876-4.897 c-1.53-3.673-10.406-8.57-12.242-9.794c-1.836-1.224-8.876-20.2-6.427-30.606c2.448-10.406,10.1-25.709,10.1-25.709 L322.292,396.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M266.085,449.721 c0,0,32.657,5.535,48.156,4.428c15.498-1.107,11.624-9.686,8.026-12.454c-3.598-2.768-12.731-2.768-12.731-2.768 S283.521,449.167,266.085,449.721z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M233.806,395.936c0,0-7.05-3.878-0.353-27.848c6.698-23.97-0.705-44.768-19.74-59.221c-19.035-14.453-48.646-4.23-61.688,10.223 c-13.043,14.453-23.97,42.301-13.748,70.501c10.223,28.2,26.79,28.553,29.963,29.963c3.173,1.41-14.1-11.633-7.755-33.488 c6.345-21.855,16.92-12.338,17.273,7.403c0.352,19.74,15.51,38.423,32.43,34.898c16.92-3.525,28.2-21.503,28.2-21.503 L233.806,395.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M160.485,386.066c2.552-8.792,5.789-12.499,8.77-12.514c0.223-1.647,0.395-3.194,0.395-4.054c0-2.467-5.288-1.057-5.288-1.057 s4.583-2.468,5.993-7.403c1.41-4.935-15.863,5.993-15.863,5.993s2.468-10.928,2.115-13.395s-8.46,3.525-8.46,3.525 s0.705-4.23,0.352-8.46c-0.352-4.23-6.345,6.698-6.345,6.698s0-12.338-0.353-17.273c-0.082-1.146-0.527-1.411-1.159-1.152 c-6.522,14.704-9.268,33.578-2.366,52.618c10.223,28.2,26.79,28.553,29.963,29.963 C171.413,420.964,154.14,407.921,160.485,386.066z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M310.968,263.484 c0,0,5.509,11.578,5.509,30.606c0,14.385-7.958,38.87-22.955,48.052c-14.997,9.182-43.174,25.07-54.785,41.93 c-22.342,32.443-2.448,53.561,11.936,62.437c14.385,8.876,46.827,3.367,57.54-3.979c10.712-7.345,17.139-18.67,14.691-28.464 c-2.448-9.794-2.448-9.794-2.448-9.794s14.079-8.57,29.688-18.364c15.609-9.794,18.058-20.2,17.139-25.097 c-0.918-4.897-0.918-4.897-0.918-4.897s3.367,8.264,4.591,4.285c1.224-3.979,2.142-11.936,0.612-15.303 c-1.53-3.367-5.509-11.018-5.509-11.018s6.733,3.061,3.979-3.673c-2.755-6.733-8.264-9.182-12.548-21.118 c-4.285-11.936-13.099-27.505-15.915-39.788c-2.816-12.283-4.591-16.527-4.591-16.527S316.783,255.22,310.968,263.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M366.059,333.878 c0,0,6.733,3.061,3.979-3.673c-2.755-6.733-8.264-9.182-12.548-21.118c-4.285-11.936-13.099-27.505-15.915-39.788 c-2.816-12.283-4.591-16.527-4.591-16.527s-7.38,0.898-14.503,3.43c3.209,7.218,9.978,23.66,12.055,38.194 c2.754,19.282,1.836,29.382-1.224,40.094c-3.061,10.712-11.63,31.83-21.73,39.176c-10.1,7.345-17.139,7.958-27.546,11.63 c-10.406,3.673-15.609,7.346-15.609,7.346s19.27-4.056,28.464-3.673c14.691,0.612,23.567,15.303,23.567,15.303 s14.079-8.57,29.688-18.364c15.609-9.794,18.058-20.2,17.139-25.097c-0.918-4.897-0.918-4.897-0.918-4.897 s3.367,8.264,4.591,4.285c1.224-3.979,2.142-11.936,0.612-15.303C370.038,341.529,366.059,333.878,366.059,333.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M299.337,355.302 c0,0,0.612,13.467-0.918,23.567s-4.285,19.588-4.285,19.588l3.979-4.591l0.306,8.876l5.203-7.958c0,0-0.918,13.467,3.061,25.097 c3.979,11.63,12.855,30.606,16.527,33.667c3.673,3.061,13.161,6.121,16.833,3.061c3.673-3.061,4.591-5.815,1.53-8.57 c-3.061-2.755-11.936-3.061-12.855-3.673c-0.918-0.612-10.406-18.67-9.182-27.852c1.224-9.182,20.2-22.342,17.751-45.297 c-2.448-22.955-13.773-40.4-13.773-40.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M337.206,194.434 l-28.418-0.955c0,0-11.702-24.597-33.91-33.91c-13.001-5.452-22.448-18.866-21.493-8.358c0.955,10.507,3.343,33.672,11.463,43.701 c8.119,10.03,21.254,9.791,21.254,9.791s-25.552,22.925-28.657,36.299c-3.104,13.373,5.97,2.388,5.97,2.388 s-3.821,15.761-1.433,17.672c2.388,1.91,10.985-9.075,10.985-9.075s-2.149,5.254,1.672,3.343 c3.821-1.911,10.03-7.403,14.328-8.358c4.299-0.955,13.851,7.403,21.254,17.91c7.403,10.508,10.06,13.984,14.567,12.896 c6.925-1.672,11.94-26.269,26.985-30.328c15.045-4.06,24.836,0,29.373,4.776c4.537,4.776,8.358,5.015,7.881,3.105 c-0.478-1.911-1.433-3.343-1.433-3.343s4.06,6.448,5.492,4.06c1.433-2.388,0.955-7.403-0.716-10.985 c-1.672-3.582-3.821-6.925-3.821-6.925s3.343,3.343,2.627,0.478c-0.716-2.866-7.642-14.328-11.94-21.493 c-4.299-7.164-9.314-10.746-9.314-10.746s12.418-8.597,13.612-20.537c1.194-11.94,2.388-26.985,4.298-35.582 c1.91-8.597,0.478-8.597-2.388-6.448c-2.866,2.149-7.642,5.492-21.015,17.91C351.057,174.136,338.161,186.315,337.206,194.434z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M296.212,175.319c-5.422-5.996-12.553-12.068-21.335-15.75c-13.001-5.452-22.448-18.866-21.492-8.358 c0.42,4.621,1.118,11.69,2.458,19.013C262.505,171.848,288.331,177.848,296.212,175.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M385.445,143.808c-2.866,2.149-7.642,5.492-21.015,17.91c-8.202,7.617-16.22,15.141-21.418,21.696 c1.051,2.21,2.169,3.771,3.306,4.121c5.114,1.574,22.424-2.754,22.424-2.754l15.132-2.421 c1.087-11.264,2.229-24.323,3.958-32.105C389.744,141.658,388.311,141.658,385.445,143.808z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M385.445,143.808 c-2.546,1.909-6.616,4.778-16.867,14.099c-6.207,7.239-12.849,16.068-16.327,24.11c-7.642,17.672,5.731,24.358,10.269,24.597 c4.537,0.239,7.403-0.239,7.403-0.239s12.418-8.597,13.612-20.537c1.194-11.94,2.388-26.985,4.299-35.582 C389.744,141.658,388.311,141.658,385.445,143.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M254.676,146.78 c-1.08,0.14-1.562,1.444-1.291,4.431c0.955,10.507,3.343,33.672,11.463,43.701c8.119,10.03,21.254,9.791,21.254,9.791 s0.955-0.478,3.821-1.672c2.866-1.194,8.836-5.731-0.239-16.717C280.921,175.708,256.355,148.629,254.676,146.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M313.245,269.127 c5.208,7.185,7.713,9.576,11.544,8.651c2.472-0.597,4.703-4.121,7.232-8.584C324.187,260.972,316.934,265.56,313.245,269.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M309.743,217.837c-0.207,0-0.405,0.061-0.597,0.148c-0.909,0.171-2.681,0.28-4.061-1.028 c-1.937-1.835-1.835-2.753-1.835-2.753s-0.306,2.549,0.51,3.671c0.816,1.122,3.365,1.631,3.365,1.631s-1.428,0.816-2.447,0.918 c-1.02,0.102-2.549-0.918-2.549-0.918s0.891,1.568,3.059,2.039c0.807,0.175,1.564,0.12,2.196-0.017 c-0.011,0.162-0.028,0.32-0.028,0.487c0,2.308,1.069,4.179,2.388,4.179s2.388-1.871,2.388-4.179 C312.132,219.709,311.062,217.837,309.743,217.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M336.646,217.837c0.207,0,0.405,0.061,0.597,0.148c0.909,0.171,2.681,0.28,4.061-1.028 c1.937-1.835,1.835-2.753,1.835-2.753s0.306,2.549-0.51,3.671c-0.816,1.122-3.365,1.631-3.365,1.631s1.427,0.816,2.447,0.918 c1.02,0.102,2.549-0.918,2.549-0.918s-0.891,1.568-3.059,2.039c-0.807,0.175-1.564,0.12-2.196-0.017 c0.011,0.162,0.028,0.32,0.028,0.487c0,2.308-1.069,4.179-2.388,4.179c-1.319,0-2.388-1.871-2.388-4.179 C334.258,219.709,335.327,217.837,336.646,217.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M299.121,213.055c0,0-0.248-2.971,5.199-4.952c5.447-1.981,8.171-0.248,8.171-0.248 s-2.701-4.94-8.396-3.454C298.401,205.887,299.121,213.055,299.121,213.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M333.068,207.316c0,0,2.266-1.938,7.057,1.323c4.792,3.261,4.978,6.484,4.978,6.484 s2.881-5.042-1.654-8.793C338.915,202.578,333.068,207.316,333.068,207.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M311.324,261.934 c-2.189-9.972-0.73-25.295-6.567-28.457c-5.837-3.162-17.026,1.946-24.565,9.242c-3.536,3.422-6.43,7.486-8.507,10.837 c0.785-0.934,1.282-1.569,1.282-1.569s-2.149,5.254,1.672,3.343c3.821-1.91,10.03-7.403,14.328-8.358 c4.299-0.955,13.851,7.403,21.254,17.91c0.943,1.339,1.808,2.561,2.611,3.677C312.384,266.664,311.877,264.456,311.324,261.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M347.321,232.018 c-10.215-1.946-10.215,6.81-10.702,14.593c-0.487,7.783-4.599,22.582-4.599,22.583c4.554-8.038,10.08-19.134,19.753-21.745 c15.045-4.06,24.836,0,29.373,4.776C373.382,240.571,357.536,233.964,347.321,232.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M304.27,257.799c0,0-6.081-10.702-3.405-19.701"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 297.46,
    y1: 237.855,
    x2: 303.054,
    y2: 237.612
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M340.754,254.881c0,0,3.892-7.297,4.378-10.702 c0.487-3.405-0.243-6.324-0.243-6.324"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M341.727,238.585c0,0,3.648-1.946,5.837-0.73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fox_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M496.115,385.299c0,0,7.584,0.292,11.959-15.751c4.375-16.043,0.875-31.211,19.252-42.003 c18.377-10.793,37.628-4.667,46.962,8.459c9.334,13.126,10.501,35.878,6.709,49.587c-3.792,13.71-14.585,19.543-14.585,19.543 s4.375-20.71-7.584-25.377c-11.959-4.667-7.292,18.376-30.919,22.752c-23.627,4.375-33.836-13.126-33.836-13.126L496.115,385.299 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M564.919,368.339c0,0-0.771-6.426,0.257-11.309c1.028-4.884,10.024,2.827,10.024,2.827s-1.285-6.683,0-11.309 c0.863-3.106,4.157,1.549,6.23,4.945c2.371,11.171,1.963,23.437-0.433,32.098c-3.792,13.71-14.585,19.543-14.585,19.543 s3.798-18.001-5.383-24.217c0.923-1.736,2.861-2.039,2.861-2.039s-5.398-4.37-6.426-7.968 C556.436,367.311,564.919,368.339,564.919,368.339z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M397.261,418.543 c0,0-4.667,7.584-9.042,13.418c-4.375,5.834-2.848,12.546-3.792,18.377c-0.944,5.83,6.711,11.611,8.562,7.387 c1.851-4.224-0.376-4.979-1.388-8.645c-1.012-3.666,0.41-10.701,4.785-12.743c4.375-2.042,14.876-11.376,14.876-11.376 L397.261,418.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M457.932,420.877 c0,0,2.917,8.459,8.459,12.834c5.542,4.375,13.709,6.417,14.585,9.626c0.875,3.209,0.292,13.126-0.875,13.71 c-1.167,0.583-12.543,5.542-11.668,8.167c0.875,2.625,6.417,2.917,10.209,2.333c3.792-0.583,11.376-7.584,11.668-11.959 c0.292-4.375,2.334-13.709,0.292-17.793c-2.042-4.084-14.001-13.418-16.626-17.793 C471.35,415.626,459.391,415.626,457.932,420.877z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M408.929,429.919c0,0-14.585-0.875-17.21-23.335c-2.625-22.46,2.625-33.253,3.792-39.086c1.167-5.834,1.167-14.876,1.167-14.876 l14.001,2.917c0,0-2.625,19.888,6.417,25.139c9.042,5.25,18.96,9.043,39.378,2.334c20.418-6.709,35.705-9.787,46.757,5.891 c6.342,8.997,2.247,23.516-5.629,30.225c-7.876,6.709,0,18.96,3.792,22.168c3.792,3.209-3.209,14.585-5.542,20.418 s-10.209,12.543-12.543,10.501c-2.334-2.042-1.458-5.542,1.458-8.459s4.959-5.834,4.959-5.834s4.085-11.382-1.167-16.626 c-2.586-2.583-14.001-11.668-16.335-15.46c0,0-21.293,3.792-27.711,4.084c-6.417,0.292-17.501,0.292-17.501,0.292 L408.929,429.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M472.225,425.835c0,0-8.932-10.078-4.219-20.368"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M427.013,430.211l-18.085-0.292c0,0-14.585-0.875-17.21-23.335c-2.625-22.46,2.625-33.253,3.792-39.086 c1.167-5.834,1.167-14.876,1.167-14.876l6.481,1.35c-1.505,6.663-3.974,19.409-3.564,29.861 c0.583,14.876,8.459,33.253,17.793,37.628c9.334,4.375,30.919,4.375,41.128,4.084c10.209-0.292,13.71,0.292,13.71,0.292 s-21.293,3.792-27.711,4.084C438.098,430.211,427.013,430.211,427.013,430.211z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M409.512,402.208 c0,0-2.333,5.834,0,20.127c2.333,14.293,3.209,26.836,2.625,32.669c-0.583,5.834-3.792,8.751-6.417,10.209 c-2.625,1.458-3.209,6.125,1.75,6.709c4.959,0.583,8.167-1.167,10.793-7.292c2.625-6.125,7.292-26.544,8.751-34.419 s4.667-16.335,4.667-16.335"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M402.803,312.951c0,0-13.418-13.709-23.335-19.835s-25.96-9.334-24.794-5.542c1.167,3.792,12.251,15.751,15.46,22.168 c3.209,6.417,5.25,13.709,5.25,13.709s21.002-2.917,24.21-5.834C402.803,314.701,402.803,312.951,402.803,312.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M354.674,287.574c0.714,2.32,5.14,7.698,9.204,12.993c6.381,2.542,18.25,6.652,21.262,3.409c1.287-1.386,1.443-3.628,1.045-6.065 c-2.289-1.807-4.584-3.477-6.717-4.795C369.55,286.991,353.507,283.782,354.674,287.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M388.641,321.155c-6.454,1.352-13.256,2.297-13.256,2.297s-2.042-7.292-5.25-13.709c-3.209-6.417-14.293-18.376-15.46-22.168 c-0.156-0.507,0.004-0.885,0.408-1.152C369.774,287.508,385.128,314.592,388.641,321.155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M446.265,328.411c0,0-13.126,2.625-18.085-6.125c-4.959-8.751,0-15.46-5.834-28.586c-5.834-13.126-18.085-30.919-19.543-29.169 c-1.458,1.75-3.5,22.752-3.209,28.877c0.292,6.126,1.459,16.043-1.458,17.793c-2.917,1.75-21.002,10.792-28.294,9.917 c-7.292-0.875-16.626-7.876-17.21,0.875c-0.583,8.751,10.501,19.543,21.585,27.711c11.084,8.167,28.294,10.501,39.378,9.918 c11.084-0.583,24.21-7.584,25.085-9.918c0.875-2.333-5.542-1.75-5.542-1.75s7.292-2.042,10.501-5.834 c3.209-3.792-0.583-7.876-0.583-7.876S447.14,331.911,446.265,328.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M419.076,304.818c1.775-1.521,2.526-6.624,2.792-12.17c-5.998-13.003-17.645-29.82-19.065-28.117 c-1.214,1.457-2.83,16.241-3.171,24.694C405.057,295.671,415.829,307.601,419.076,304.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M363.371,333.255c6.912,0,18.721-4.608,27.074-1.44c8.353,3.168,12.673,15.265,8.641,23.042 c-0.717,1.382-1.583,2.574-2.516,3.613c-7.935-1.421-16.113-4.169-22.352-8.766c-7.879-5.805-15.753-12.936-19.441-19.718 C357.281,331.718,360.353,333.255,363.371,333.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M404.845,318.493c-2.558-1.637-4.533-4.472-6.106-7.862c2.129-2.722,1.124-11.577,0.855-17.224 c-0.292-6.125,1.75-27.127,3.209-28.877c0,0,7.001,23.335,10.501,39.67C416.804,320.535,412.137,323.16,404.845,318.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M361.408,318.724c-1.071,3.013-3.263,7.67-7.159,10.24c-1.161-2.404-1.765-4.753-1.617-6.97 C352.999,316.5,356.814,317.215,361.408,318.724z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#263238"
    },
    cx: 385.01,
    cy: 323.89,
    rx: 2.042,
    ry: 3.354
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M369.259,345.621 c0,0,11.376-0.583,11.376-11.668"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 384.427,
    y1: 334.245,
    x2: 378.593,
    y2: 333.37
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Fox_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M286.603,430.138 l8.87,24.895c0,0,6.295,1.431,5.437,5.151c-0.858,3.72-7.44,2.861-10.301,2.003c-2.861-0.858-16.31-21.175-16.31-21.175 L286.603,430.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M231.95,463.617 c0,0,20.602,5.437,30.045,2.862c9.443-2.575,3.72-7.44-7.44-8.871S231.95,463.617,231.95,463.617z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M192.462,418.406c0,0-6.581,2.003-19.458-10.874c-12.876-12.876-31.762-50.934-44.924-60.662 c-13.163-9.729-40.346-8.012-51.792,7.726c-11.446,15.738-0.572,25.181-0.572,25.181s6.581-9.729,10.301-9.729 c3.72,0,7.726,14.307,12.59,38.343c4.864,24.036,28.614,49.503,65.241,39.774c22.476-5.97,28.328-20.889,28.614-21.747 C192.748,425.56,192.462,418.406,192.462,418.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M128.08,346.87 c-13.163-9.729-40.346-8.012-51.792,7.726c-11.446,15.738-0.572,25.181-0.572,25.181s6.581-9.729,10.301-9.729 s7.726,14.307,12.59,38.343c0.311,1.538,0.702,3.082,1.167,4.622c1.799,2.745,3.366,4.408,3.698,2.531 c0.859-4.864,0.859-16.882,0.859-16.882s2.289,6.295,3.148,3.148c0.858-3.148-0.286-11.446-0.286-11.446s7.44,7.154,8.87,6.009 c1.431-1.145-2.575-14.593-2.575-14.593s12.018,11.446,14.307,9.443c2.289-2.003-1.145-14.307-1.145-14.307 s9.729,3.434,10.587,2.575c0.858-0.858-5.151-11.732-5.151-11.732s9.443,5.437,10.015,5.437c0.572,0-2.003-9.443-2.003-9.443 l3.394,1.44C137.99,357.147,132.684,350.273,128.08,346.87z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M258.561,354.596 c0,0-1.431,14.021-11.732,27.47c-10.301,13.449-19.744,10.874-34.623,17.455c-14.879,6.581-27.47,16.596-21.461,35.768 c6.009,19.172,24.322,29.759,46.069,29.187c21.747-0.572,31.19-10.587,33.193-12.304c2.003-1.717,5.151-3.72,17.169-19.172 c12.018-15.452,7.726-28.328,7.726-28.328l5.151,7.726c0,0-0.286-9.156-2.289-14.021c-2.003-4.864-4.864-11.732-6.867-17.169 c-2.003-5.437-10.587-17.741-14.021-26.897c-3.434-9.157-4.292-10.873-4.292-10.873L258.561,354.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M294.901,404.671 l5.151,7.726c0,0-0.286-9.157-2.289-14.021c-2.003-4.865-4.864-11.732-6.867-17.169c-2.003-5.437-10.587-17.741-14.021-26.897 c-1.065-2.84-1.881-4.962-2.502-6.541l-0.932,0.532c0,0,6.009,28.042,8.87,41.205c2.861,13.163,0.286,27.756-4.292,37.199 c-4.578,9.443-13.735,20.602-15.166,26.611c-0.456,1.916-0.882,3.597-1.216,4.992c4.801-2.65,7.421-5.324,8.369-6.137 c2.003-1.717,5.151-3.72,17.169-19.172C299.194,417.548,294.901,404.671,294.901,404.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M252.266,394.942 c0,0,14.593,58.087,17.741,64.382c3.148,6.295,5.723,8.298,8.584,8.584c2.861,0.286,11.446,0.858,10.015-4.292 s-8.012-6.867-8.012-6.867l-3.148-66.385"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M212.492,426.704 c0,0,23.178-10.587,38.057-1.717c14.88,8.87,13.021,23.147,11.089,33.32"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M293.059,291.225c0,0-12.264,11.949-20.125,13.522c-7.861,1.572-25.471,2.516-33.332,0.943 c-7.861-1.572-33.646-5.66-45.281-9.434c-11.635-3.773-13.207-2.201-10.691,2.83c2.516,5.031,5.975,17.924,23.27,23.584 c17.295,5.66,27.672-1.258,27.672-1.258s-0.629,5.975,6.918,13.521c7.547,7.547,14.15,19.496,13.207,25.156 c-0.943,5.66-5.66,7.547-5.66,7.547s6.289,0,10.062-1.258c3.773-1.258,5.975-3.145,5.975-3.145s-4.088,4.402-0.629,4.088 c3.459-0.314,12.893-6.289,12.893-6.289s0.943,6.289,4.088,4.402c3.145-1.887,12.578-3.145,13.207-21.383 s6.184-35.827,5.975-44.338C300.451,293.433,300.505,286.56,293.059,291.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M230.834,311.149c1.582-2.75-7.033-6.859-13.973-9.64c-8.418-1.623-17.053-3.472-22.54-5.252 c-11.635-3.773-13.207-2.201-10.691,2.83c2.516,5.031,5.975,17.924,23.27,23.584c1.238,0.405,2.437,0.739,3.603,1.023 C217.906,320.018,229.05,314.25,230.834,311.149z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M249.979,322.671c0,0-14.15,5.66-26.728,16.352c-12.578,10.691-27.043,21.383-25.785,23.27 c1.258,1.887,12.578-0.314,12.578-0.314s22.955,1.572,34.904-5.66c11.949-7.232,13.207-28.93,13.207-28.93"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M197.465,362.292c1.258,1.887,12.578-0.314,12.578-0.314s9.538,0.65,19.517-0.823c1.698-5.36,5.745-19.296,3.644-24.325 c-0.745-1.784-2.471-2.265-4.558-2.043c-1.8,1.311-3.614,2.721-5.396,4.236C210.673,349.714,196.208,360.405,197.465,362.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M210.044,361.977c0,0,22.955,1.572,34.904-5.66c5.272-3.191,8.462-9.198,10.381-14.915c0.383-3.244,0.318-7.338-1.577-9.612 c-3.145-3.773-10.062,2.516-17.924,11.32c-7.861,8.805-38.363,19.182-38.363,19.182 C198.723,364.178,210.044,361.977,210.044,361.977z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M274.506,313.709c0,1.303-1.76,2.358-3.931,2.358s-3.931-1.056-3.931-2.358 c0-1.302,1.76-2.358,3.931-2.358S274.506,312.406,274.506,313.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M300.28,293.978 c-1.145,2.138-3.275,5.658-7.221,11.083c-7.547,10.377-13.207,8.49-17.295,17.295c-4.088,8.805,10.691,12.264,14.779,16.98 c2.024,2.335,3.275,4.437,4.025,5.966c0.024-0.41,0.049-0.821,0.063-1.249c0.629-18.238,6.184-35.827,5.975-44.338 C300.557,297.735,300.529,295.697,300.28,293.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M293.059,291.225c0,0-1.234,1.202-3.168,2.892c2.063,2.265,5.61,5.148,10.711,5.877c-0.001-0.089,0.006-0.191,0.004-0.279 C300.451,293.433,300.505,286.559,293.059,291.225z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M283.625,320.784 c0,0,7.232,4.402,14.15-2.516"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 285.198,
    y1: 317.954,
    x2: 281.739,
    y2: 322.985
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingTwo);
export default __webpack_public_path__ + "static/media/landingTwo.5f38547e085b99a072efc03d2021dad3.svg";
export { ForwardRef as ReactComponent };